import createIcon from '../../createIcon';

/**
 * @component @name EventBusy
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOS4zMSAxOEwxMS43NSAxNS41NkwxNC4xOSAxOEwxNS4yNSAxNi45NEwxMi44MSAxNC41TDE1LjI1IDEyLjA2TDE0LjE5IDExTDExLjc1IDEzLjQ0TDkuMzEgMTFMOC4yNSAxMi4wNkwxMC42OSAxNC41TDguMjUgMTYuOTRMOS4zMSAxOFpNMTkgNEgxOFYySDE2VjRIOFYySDZWNEg1QzMuODkgNCAzLjAxIDQuOSAzLjAxIDZMMyAyMEMzIDIxLjEgMy44OSAyMiA1IDIySDE5QzIwLjEgMjIgMjEgMjEuMSAyMSAyMFY2QzIxIDQuOSAyMC4xIDQgMTkgNFpNMTkgMjBINVY5SDE5VjIwWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const EventBusy = createIcon('EventBusy', [
  [
    'path',
    {
      d: 'M9.31 18L11.75 15.56L14.19 18L15.25 16.94L12.81 14.5L15.25 12.06L14.19 11L11.75 13.44L9.31 11L8.25 12.06L10.69 14.5L8.25 16.94L9.31 18ZM19 4H18V2H16V4H8V2H6V4H5C3.89 4 3.01 4.9 3.01 6L3 20C3 21.1 3.89 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM19 20H5V9H19V20Z',
      key: 'z455jn',
    },
  ],
]);

export default EventBusy;
